// Mock data for Natalia Regina VetClin

export const clinicInfo = {
  name: "Natalia Regina VetClin",
  doctorName: "Dra. Natalia Regina",
  phone: "11949321508",
  email: "nataliareginavetclin@gmail.com",
  whatsapp: "5511949321508",
  address: "Atendimento a domicílio",
  hours: "Segunda a Sexta: 8h - 18h | Sábado: 9h - 13h",
  instagram: "@nataliareginavetclin",
  facebook: "NataliaReginaVetClin"
};

export const services = [
  {
    id: 1,
    title: "Consultas Veterinárias",
    description: "Atendimento completo com exames clínicos detalhados para cães e gatos",
    icon: "stethoscope"
  },
  {
    id: 2,
    title: "Vacinação",
    description: "Programas de vacinação para filhotes e adultos, mantendo a saúde em dia",
    icon: "syringe"
  },
  {
    id: 3,
    title: "Em domicílio",
    description: "Atendimento a domicílio para trazer comodidade ao pet e tutor",
    icon: "heart-pulse"
  },
  // {
  //   id: 3,
  //   title: "Cirurgias",
  //   description: "Procedimentos cirúrgicos com equipamentos modernos e anestesia segura",
  //   icon: "activity"
  // },
  // {
  //   id: 4,
  //   title: "Exames Laboratoriais",
  //   description: "Análises clínicas completas para diagnóstico preciso",
  //   icon: "microscope"
  // },
  // {
  //   id: 5,
  //   title: "Banho e Tosa",
  //   description: "Cuidados estéticos com carinho e profissionalismo",
  //   icon: "droplet"
  // },
  // {
  //   id: 6,
  //   title: "Emergências",
  //   description: "Atendimento de urgência para casos que necessitam atenção imediata",
  //   icon: "heart-pulse"
  // }
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Silva",
    pet: "Rex",
    text: "Excelente profissional! A Dra. Natalia cuidou do meu cachorro com muito carinho e atenção. Recomendo!",
    rating: 5
  },
  {
    id: 2,
    name: "João Santos",
    pet: "Mimi",
    text: "Atendimento maravilhoso! Minha gata foi muito bem tratada. Clínica limpa e organizada.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Paula",
    pet: "Thor",
    text: "Profissionalismo e amor pelos animais. A Dra. Natalia é incrível e sempre explica tudo com clareza.",
    rating: 5
  }
];

export const about = {
  title: "Sobre a Clínica",
  description: "A Natalia Regina VetClin nasceu do amor incondicional pelos animais e do compromisso em oferecer cuidados veterinários de excelência. Com anos de experiência, a Dra. Natalia Regina dedica-se a proporcionar saúde e bem-estar para seu melhor amigo.",
  mission: "Nossa missão é oferecer atendimento veterinário humanizado, com tecnologia de ponta e muito carinho.",
  values: ["Amor aos animais", "Excelência no atendimento", "Transparência", "Compromisso com a vida"]
};

// Mock appointments for admin panel
export const mockAppointments = [
  {
    id: 1,
    petName: "Rex",
    ownerName: "Maria Silva",
    phone: "11987654321",
    date: "2025-08-20",
    time: "10:00",
    service: "Consulta Veterinária",
    status: "pending"
  },
  {
    id: 2,
    petName: "Mimi",
    ownerName: "João Santos",
    phone: "11876543210",
    date: "2025-08-21",
    time: "14:00",
    service: "Vacinação",
    status: "confirmed"
  }
];